export default __webpack_public_path__ + "static/media/logo.f51ed8bb.png";